import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiBell, FiCalendar, FiArrowRight, FiCheckCircle } from 'react-icons/fi';
import { getNotices } from '../../services/api';
import { NOTICE_CATEGORIES } from '../Notices/noticesConfig';
import styles from './NoticeboardWidget.module.css';

export default function NoticeboardWidget({ derasarId }) {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    if (!derasarId) return;
    getNotices(derasarId)
      .then((res) => setNotices(Array.isArray(res?.data) ? res.data : []))
      .catch(() => {});
  }, [derasarId]);

  const dashboardNotices = notices.filter((n) => n.category === 'dashboard');
  const pinnedNotice = notices.find((n) => n.isPinned && n.category !== 'dashboard');
  const shownIds = new Set(
    [...dashboardNotices.map((n) => n.id), pinnedNotice?.id].filter(Boolean)
  );
  const recentNotices = notices.filter((n) => !shownIds.has(n.id)).slice(0, 3);
  const allDisplayed = [
    ...dashboardNotices,
    ...(pinnedNotice ? [pinnedNotice] : []),
    ...recentNotices,
  ];

  const getCategoryLabel = (cat) =>
    NOTICE_CATEGORIES.find((c) => c.value === cat)?.label || cat || '';

  const getCategoryColor = (cat) =>
    NOTICE_CATEGORIES.find((c) => c.value === cat)?.color || '#6b7280';

  return (
    <div className="card" style={{ marginBottom: 20 }}>
      <div className="card-header">
        <h3 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <FiBell size={16} /> Notice Board
        </h3>
        <Link to="/derasar/notices" className="btn btn-ghost btn-sm">View all →</Link>
      </div>

      {allDisplayed.length === 0 ? (
        <div className={styles.empty}>
          <FiBell size={32} style={{ opacity: 0.3 }} />
          <p>No notices posted yet.</p>
        </div>
      ) : (
        <div className={styles.list}>
          {allDisplayed.map((notice) => {
            const isDashboard = notice.category === 'dashboard';
            const isPinned = notice.isPinned && !isDashboard;
            return (
              <div
                key={notice.id}
                className={`${styles.noticeCard} ${isDashboard ? styles.cardDashboard : isPinned ? styles.cardPinned : ''}`}
                onClick={() => navigate(`/derasar/notices/${notice.id}`)}
              >
                <div className={styles.cardHeader}>
                  <div className={styles.cardTitle}>{notice.title}</div>
                  <div className={styles.cardBadges}>
                    {isPinned && (
                      <span className={styles.pinnedChip}>
                        <FiCheckCircle size={10} /> Pinned
                      </span>
                    )}
                    {notice.category && (
                      <span
                        className={styles.categoryBadge}
                        style={{ backgroundColor: getCategoryColor(notice.category) }}
                      >
                        {getCategoryLabel(notice.category)}
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className={styles.cardContent}
                  dangerouslySetInnerHTML={{ __html: notice.content }}
                />

                <div className={styles.cardFooter}>
                  <div className={styles.cardMeta}>
                    <FiCalendar size={12} />
                    {new Date(notice.createdAt).toLocaleDateString('en-IN')}
                  </div>
                  <div className={styles.cardAction}>Read More <FiArrowRight size={14} /></div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
